import React, { useState } from "react";
import SignupPage from "../../entities/SignupPage";
import AuthService from "../../api/AuthService";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../context/AlertContext";
import { refreshDateFormat } from "../../utils/dateFormatStore";


const Signup = () => {
  const navigate = useNavigate();
  const {showAlert} = useAlert();
  const [loading,setLoading] = useState(false);
  const handleSignUp = async (data) => {
    setLoading(true)
    try {
      const result = await AuthService.signup(data);
      if (result?.success === true) {
        setLoading(false)
        localStorage.setItem("accessToken", result?.data?.token);
        refreshDateFormat();
        localStorage.setItem("id", result?.data?.id);
        localStorage.setItem("companyId", result?.data?.companyId)
        localStorage.setItem("email", result.data.email);
        localStorage.setItem("role", result.data.role);
        localStorage.setItem("employeeId", result?.data?.role === "employee" ?result?.data?.userId:result?.data?.userId);
        // A fresh registration is always unverified — persist the flags so the
        // verify-email screen and the global 403 gate stay in sync.
        localStorage.setItem("isEmailVerified", result?.data?.isEmailVerified ?? false);
        localStorage.setItem("isPhoneVerified", result?.data?.isPhoneVerified ?? false);
        // Free-tier rework: registration no longer creates a subscription, so a
        // new admin has none until they pick a plan. Seed the flag so the
        // "Purchase a plan" nudge shows reliably (getProfileView reconciles later).
        localStorage.setItem("is_subscription", false);

        showAlert(result?.message,"success");
        // Do not route into the app until the email is verified.
        navigate("/verify-email");
      } else {
        
        setLoading(false)
        showAlert(result?.message,"error");
      }
    } catch (error) {
      setLoading(false)
      showAlert(error,"error");
    }
  };

  return (
    <SignupPage handleSignUp={handleSignUp} loading={loading}/>
  )

}

export default Signup;
